export default {
    primary: "myriad-pro, sans-serif",
    secondary: "myriad-pro-semiextended, sans-serif",
} as const;
